/** @jsxImportSource @emotion/react */
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSpinner} from '@fortawesome/free-solid-svg-icons';

export default function FullPageLoader() {
  return (
    <div
      role="progressbar"
      css={{
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        color: '#fff',
        zIndex: 999,
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        minHeight: '520px',
        maxHeight: '100vh',
      }}
    >
      <FontAwesomeIcon icon={faSpinner} pulse size={'4x'} />
    </div>
  );
}
